<template>
  <div class="messageContainer">
    <a href="https://projectsakura.github.io/blog/#/donation" target="blank">
      <p class="message">Become a donator and get your name or organisation's logo on our donations page.</p>
    </a>
  </div>
</template>
<script>
export default {
  name: "Donate",
};
</script>
<style>
.messageContainer{
  border-radius: 10px;
  margin: 2vh 1vh;
}
.message{
  font-size: 1.3em;
  /* color: #5485D8; */
  padding: 1vh;
  margin: 0;
}
</style>
